module.exports = __webpack_public_path__ + "static/media/linkedin.69659792.svg";